import firebaseAnalytics from '@react-native-firebase/analytics';
import {isEmpty} from 'lodash/fp';

import {log} from '/util/logger.util';

export class FirebaseAnalyticsBackend {
  analytics: any;

  lastScreenName: any;

  verbose: any;

  constructor({verbose}: any = {}) {
    this.verbose = verbose;
    this.lastScreenName = null;
    this.analytics = firebaseAnalytics;
  }

  setAnalyticsCollectionStatus(isEnabled: any) {
    this.analytics().setAnalyticsCollectionEnabled(isEnabled);
  }

  logUserId(userId: any) {
    this.analytics().setUserId(userId.toString());

    if (this.verbose) {
      log(`[FirebaseAnalytics] user ID: ${userId}`);
    }
  }

  logUserProperties({
    coach_id,
    competency_view,
    current_rank,
    highest_achieved_rank,
    certification_status,
  }: any) {
    const payload = {
      coach_id: coach_id.toString(),
      competency_view,
      current_rank,
      highest_achieved_rank,
      certification_status,
    };

    this.analytics().setUserProperties(payload);

    if (this.verbose) {
      log(`[FirebaseAnalytics] user properties: ${JSON.stringify(payload)}`);
    }
  }

  logCurrentScreen(screenName: any) {
    if (!isEmpty(screenName) && screenName !== this.lastScreenName) {
      this.lastScreenName = screenName;

      this.analytics().logScreenView({screen_name: screenName});

      if (this.verbose) {
        log(`[FirebaseAnalytics] current screen: ${screenName}`);
      }
    }
  }

  logEvent(eventName: any, eventPayload: any) {
    this.analytics().logEvent(eventName, eventPayload);

    if (this.verbose) {
      log(
        `[FirebaseAnalytics] event: ${eventName}; payload: ${JSON.stringify(
          eventPayload,
        )}`,
      );
    }
  }
}

export default FirebaseAnalyticsBackend;
